import { Signal } from '@angular/core';

import { BadgeColor, IconName, RtButtonVariant } from '@recruitee/user-interface';

import { TellentBrand } from '../../index';

export type TellentAppCopy = {
  name: string;
  type: string;
  description: string;
  badge?: { text: string; color: BadgeColor; icon?: IconName };
};

export type TellentAppAction = {
  handler: () => void;
  label: string;
  variant: RtButtonVariant;
  description?: string;
  analytics?: string;
  disabled?: boolean;
};

export type TellentApp = {
  brand: TellentBrand;
  copy: TellentAppCopy;
  action: TellentAppAction;
  isActive: boolean;
};

export abstract class ManageAppsService {
  public abstract getAppViewModels(): Signal<TellentApp[]>;
  public abstract fetchTellentApps(): void;
}
